import { render, staticRenderFns } from "./SwitchInput.vue?vue&type=template&id=4987f903&scoped=true&"
import script from "./SwitchInput.vue?vue&type=script&lang=js&"
export * from "./SwitchInput.vue?vue&type=script&lang=js&"
import style0 from "./SwitchInput.vue?vue&type=style&index=0&id=4987f903&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987f903",
  null
  
)

export default component.exports